// import { useEffect, useState } from "react";
// import useAxios from "../../../../Hooks/useAxios";
// import useApp from "../../../../Hooks/useApp";

// function useTable() {
//   const [limit, setLimit] = useState(10);
//   const [docs, setDocs] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const request = useAxios();

//   const { user } = useApp();

//   // Pagination
//   const [page, setPage] = useState(1);
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [hasPrevPage, setHasPrevPage] = useState(false);
//   const [total, setTotal] = useState(0);
//   const [pages, setPages] = useState(0);

//   const [order, setOrder] = useState("timestamp-desc");

//   const refetchDocs = () =>
//     getDocs({ page: page, limit: limit, userId: user.id });

//   // const [systemId, setSystemId] = useState(null);

//   useEffect(() => {
//     if (user) {
//       getDocs({ page, limit, userId: user.id });
//     }
//   }, [page, limit, order, user]);

//   async function getDocs({ page, limit, userId }) {
//     let res = await request({
//       method: "GET",
//       url: "logs/all",
//       params: {
//         page,
//         limit,
//         userId,
//       },
//       show_loading: false,
//       loadingFunc: setIsLoading,
//     });

//     if (res === "error") {
//       return;
//     }

//     setTotal(res?.pagination?.total || 0);
//     setPages(res?.pagination?.pages || 0);
//     setHasNextPage(res?.pagination?.hasNextPage || false);
//     setHasPrevPage(res?.pagination?.hasPrevPage || false);
//     setDocs(res?.docs || []);
//   }

//   function handleNext() {
//     if (hasNextPage) {
//       setPage((prevPage) => prevPage + 1);
//     }
//   }

//   function handlePrev() {
//     if (hasPrevPage) {
//       setPage((prevPage) => prevPage - 1);
//     }
//   }

//   return {
//     limit,
//     setLimit,
//     docs,
//     setDocs,
//     isLoading,
//     setIsLoading,
//     pagination: {
//       page,
//       total,
//       pages,
//       hasNextPage,
//       hasPrevPage,
//       handleNext,
//       handlePrev,
//       limit,
//       setLimit,
//       total_docs: docs.length || 0,
//     },
//     setOrder,
//     refetchDocs,
//   };
// }

// export default useTable;

import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";

function useTable() {
  const [limit, setLimit] = useState(10);
  const [docs, setDocs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const request = useAxios();
  const { user } = useApp();

  // Pagination
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  const [order, setOrder] = useState("timestamp-desc");

  const refetchDocs = () => {
    if (user?.id) {
      getDocs({ page, limit, userId: user.id, order });
    }
  };

  useEffect(() => {
    if (user?.id) {
      getDocs({ page, limit, userId: user.id, order });
    }
  }, [page, limit, order, user]);

  async function getDocs({ page, limit, userId, order }) {
    try {
      const res = await request({
        method: "GET",
        url: "logs/all",
        params: {
          page,
          limit,
          user: userId,
          order,
        },
        show_loading: false,
        loadingFunc: setIsLoading,
      });

      if (res === "error") return;

      setDocs(res.docs || []);
      setTotal(res.pagination?.total || 0);
      setPages(res.pagination?.pages || 0);
      setHasNextPage(res.pagination?.hasNextPage || false);
      setHasPrevPage(res.pagination?.hasPrevPage || false);
    } catch (error) {
      console.error("Failed to fetch logs", error);
    }
  }

  function handleNext() {
    if (hasNextPage) setPage((prev) => prev + 1);
  }

  function handlePrev() {
    if (hasPrevPage) setPage((prev) => prev - 1);
  }

  return {
    limit,
    setLimit,
    docs,
    isLoading,
    setIsLoading,
    pagination: {
      page,
      total,
      pages,
      hasNextPage,
      hasPrevPage,
      handleNext,
      handlePrev,
      total_docs: docs.length,
    },
    setOrder,
    refetchDocs,
  };
}

export default useTable;
